import { LoginForm } from '../components/auth/LoginForm';

export default function LoginPage() {
  return (
    <div className="min-h-screen bg-dark-900 flex items-center justify-center px-4">
      <LoginForm />
    </div>
  );
}
